import type { WebElement } from '../types'
import { TrackingEvent, ActionOutcome, ElementType, type CustomDimensions } from '../types'

export interface ElementClickedArgs {
  actionOutcome: ActionOutcome
  outboundUrl?: string
  webElement: WebElement
  customDimensions?: CustomDimensions[]
}

export interface ElementClickedProperties {
  actionOutcome?: ActionOutcome
  outboundUrl?: string
  webElement: WebElement
  customDimensions?: CustomDimensions[]
}

export class ElementClicked extends TrackingEvent {
  properties: ElementClickedProperties

  constructor(args: ElementClickedArgs) {
    const {
      actionOutcome = ActionOutcome.NoAction,
      outboundUrl = '',
      webElement = {
        elementType: ElementType.None,
        location: '',
        name: '',
        position: '',
        text: '',
      },
      customDimensions = [],
    } = args ?? {}
    super('ElementClicked', 'redventures.usertracking.v3.ElementClicked')

    this.properties = {
      actionOutcome,
      outboundUrl,
      webElement: {
        elementType: webElement.elementType,
        location: webElement.location,
        name: webElement.name,
        position: webElement.position,
        text: webElement.text,
      },
      customDimensions,
    }
  }
}
